/**
 * Application Constants
 * Central location for app-wide constant values
 */

// ================================
// OWNERSHIP MANAGEMENT
// ================================

/**
 * Saint Nick placeholder user account for unclaimed sequences.
 * This account serves as the default owner for sequences that don't have
 * an associated creator. Users can claim ownership by contacting support.
 */
export const SAINT_NICK_USER_ID = 'f47ac10b-58cc-4372-a567-0e02b2c3d479';

/**
 * Contact email for ownership claims and support
 */
export const OWNERSHIP_CONTACT_EMAIL = 'joey@towb.in';

/**
 * Ownership claim message template
 */
export const OWNERSHIP_CLAIM_MESSAGE = 
  'This sequence is currently unclaimed. If you are the original creator and would like to claim ownership, please contact joey@towb.in with proof of creation.';

// ================================
// OWNERSHIP CLAIM TYPES
// ================================

/**
 * Valid claim status values for sequences
 */
export type ClaimStatus = 'unclaimed' | 'pending' | 'verified';

/**
 * Valid claim status values for ownership claims
 */
export type OwnershipClaimStatus = 'pending' | 'approved' | 'rejected';

/**
 * Default claim status for new sequences
 */
export const DEFAULT_CLAIM_STATUS: ClaimStatus = 'unclaimed';

// ================================
// USER TYPES
// ================================

/**
 * Check if a user ID belongs to the Saint Nick placeholder account
 */
export const isSaintNickAccount = (userId: string): boolean => {
  return userId === SAINT_NICK_USER_ID;
};

/**
 * Get display name for Saint Nick account
 */
export const SAINT_NICK_DISPLAY_NAME = 'Saint Nick';

/**
 * Get bio for Saint Nick account
 */
export const SAINT_NICK_BIO = 
  'This is a placeholder account for unclaimed light sequences. If you created one of these sequences and would like to claim ownership, please contact joey@towb.in with proof of creation.'; 